interface InventoryClassBadgeProps {
    inventoryClass: number;
    className?: string;
    stockQuantity?: number | null;
    rolling12MSalesQty?: number | null;
    stockCoverageMonths?: number | null;
}

const CLASS_STYLES: Record<number, { bg: string; text: string; label: string }> = {
    1: { bg: 'bg-green-100', text: 'text-green-700', label: '0-3 Mts' },
    2: { bg: 'bg-lime-100', text: 'text-lime-700', label: '3-6 Mts' },
    3: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: '6-12 Mts' },
    4: { bg: 'bg-orange-100', text: 'text-orange-700', label: '12-24 Mts' },
    5: { bg: 'bg-red-100', text: 'text-red-700', label: '> 24 Mts' },
    6: { bg: 'bg-red-200', text: 'text-red-800', label: 'No Mover' },
};

function formatQty(num: number): string {
    return Math.round(num).toLocaleString('de-CH');
}

function buildTooltip(
    inventoryClass: number,
    stockQuantity?: number | null,
    rolling12MSalesQty?: number | null,
    stockCoverageMonths?: number | null,
): string | undefined {
    if (inventoryClass === 6) {
        return 'No sales in the last 12 months';
    }
    if (stockCoverageMonths == null || stockQuantity == null) {
        return undefined;
    }
    const salesPart = rolling12MSalesQty != null
        ? `12M Sales: ${formatQty(rolling12MSalesQty)}`
        : 'No 12M sales data';
    return `Coverage: ~${Math.round(stockCoverageMonths)} months\nStock: ${formatQty(stockQuantity)} / ${salesPart}`;
}

export function InventoryClassBadge({
    inventoryClass,
    className = '',
    stockQuantity,
    rolling12MSalesQty,
    stockCoverageMonths,
}: InventoryClassBadgeProps) {
    const style = CLASS_STYLES[inventoryClass] || CLASS_STYLES[6];
    const tooltip = buildTooltip(inventoryClass, stockQuantity, rolling12MSalesQty, stockCoverageMonths);

    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style.bg} ${style.text} ${className}`}
            title={tooltip}
        >
            {inventoryClass}: {style.label}
        </span>
    );
}
